import { useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { FILE_TYPES, PLATFORMS } from "shared/types/enums";

import { FMX, FT } from "./constants";
import FileGroup from "./FileGroup";
import { useFiles } from "./hooks";
import { AddFilesProps, FileUploaded } from "./types";

const AddFiles = ({
    fileValues,
    company,
    isLoading,
    isGroupExtended,
    onFileChange,
    onGroupExtensionChange
}: AddFilesProps) => {
    const { t } = useTranslation();

    const { ftFiles, fmxFiles, isFileUploadedInitial } = useFiles(fileValues);

    const [isFileUploaded, setIsFileUploaded] = useState<FileUploaded>(
        isFileUploadedInitial
    );

    const handleFileUpload = (type: FILE_TYPES) =>
        setIsFileUploaded(prev => ({ ...prev, [type]: true }));

    return (
        <div
            css={css({
                "& > div + div": {
                    marginTop: "16px"
                }
            })}
        >
            <BannerView
                data-testid="banner-message"
                bannerType={BannerType.Info}
                title={t("Dialog##create smart group banner message")}
            />

            <FileGroup
                title={t("Dialog##smart group##title", {
                    platformName: FT
                })}
                description={t("Dialog##smart group##description", {
                    platformName: FT
                })}
                files={ftFiles}
                isFileUploaded={isFileUploaded}
                company={company}
                isExtended={isGroupExtended[PLATFORMS.Ft]}
                isLoading={isLoading}
                onFileChange={onFileChange}
                onFileUpload={handleFileUpload}
                onExtensionChange={() => onGroupExtensionChange(PLATFORMS.Ft)}
            />

            <FileGroup
                title={t("Dialog##smart group##title", {
                    platformName: FMX
                })}
                description={t("Dialog##smart group##description", {
                    platformName: FMX
                })}
                files={fmxFiles}
                isFileUploaded={isFileUploaded}
                company={company}
                isExtended={isGroupExtended[PLATFORMS.Fmx]}
                isLoading={isLoading}
                onFileChange={onFileChange}
                onFileUpload={handleFileUpload}
                onExtensionChange={() => onGroupExtensionChange(PLATFORMS.Fmx)}
            />
        </div>
    );
};

export { AddFiles };
